import { Box, Checkbox, CircularProgress, FormControlLabel, TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { RootState } from "config/store";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useInfiniteQuery, useQuery } from "react-query";
import { useSelector } from "react-redux";
import { CashRegister } from "shared/network/cash-register.api";
import { getCompanySiteListPageable } from "shared/network/companysite.api";
import { listUsers } from "shared/network/user.api";
import { CompanySite, User } from "shared/types";
import displayAddress from "shared/util/displayAddress";
import { useDebouncedCallback } from "use-debounce";
import { ListboxComponent } from "views/Project/components/ProjectOfferAddDialog";
import { nextPageFunction } from "views/Reminder/ReminderForm";
import CashRegisterUserSelect from "./CashRegisterUserSelect";
import CashRegisterCompanySiteSelect from "./CashRegisterCompanySiteSelect";

type Props = {
  cashRegister?: CashRegister;
};

export type CashRegisterFormValues = {
  name: string;
  responsibleUser: User | null;
  isDefault: boolean;
  serialNumber: string;
  companySite: CompanySite | null;
};

const CashRegisterForm = ({ cashRegister }: Props) => {
  const { t } = useTranslation();

  return (
    <Box display="flex" flexDirection="column" gridGap={16}>
      <Controller
        name="name"
        defaultValue={cashRegister?.name || ""}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label={t("cashRegister.name")}
            InputLabelProps={{ shrink: true, required: true }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
        rules={{
          required: t("validation.required").toString(),
        }}
      />
      <Controller
        name="serialNumber"
        defaultValue={cashRegister?.serialNumber || ""}
        render={({ field, fieldState }) => (
          <TextField
            {...field}
            label={t("cashRegister.serialNumber")}
            InputLabelProps={{ shrink: true, required: true }}
            error={!!fieldState.error}
            helperText={fieldState.error?.message}
          />
        )}
        rules={{
          required: t("validation.required").toString(),
        }}
      />
      <CashRegisterUserSelect defaultValue={cashRegister?.responsibleUser} />
      <CashRegisterCompanySiteSelect defaultValue={cashRegister?.companySite} />
      <Controller
        name="isDefault"
        defaultValue={cashRegister?.isDefault || false}
        render={({ field: { onChange, value, ref } }) => (
          <FormControlLabel
            label={t("cashRegister.isDefault")}
            control={
              <Checkbox
                onChange={(e, checked) => onChange(checked)}
                checked={value}
                inputRef={ref}
                color="primary"
              />
            }
          />
        )}
      />
    </Box>
  );
};

export default CashRegisterForm;
